<script>
	import { goto } from '$app/navigation';
	import { page } from '$app/stores';

	export let item, categories, children, activeCategory, hoverActive, OpenCatalog;

	function changHover() {
		hoverActive = item.slug;
		children = [];
		activeCategory = null;
		if (hoverActive) {
			let par_category = categories.filter((el) => {
				return el.slug === item.slug;
			})[0];

			if (par_category) {
				activeCategory = par_category;
				children = par_category.children;

				if (children.length === 0) {
					OpenCatalog = false;
					goto('/' + item.slug);
				}
			} else {
				OpenCatalog = false;
				goto('/' + item.slug);
			}
		}
	}
</script>

<button
	on:click={() => {
		changHover();
	}}
	class:bg-black={hoverActive === item.slug}
	class:text-white={hoverActive === item.slug}
	class:text-[#000]={hoverActive != item.slug}
	class="inline-flex items-center h-[25px] pl-[29px] pr-[26px]"
>
	{#if hoverActive === item.slug}
		{@html item.icon2}
	{:else}
		{@html item.icon}
	{/if}
	<span class="text-[10px] ml-[12px]">{item.name}</span>
</button>
